// extracted by mini-css-extract-plugin
export default {"breakpointxs":"0","dependant-address-container__progress-container":"DependantAddressContainer_dependant-address-container__progress-container__3jibR"};